import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {Localiser} from "../../services/localiser";
import {zona} from "../../models/zona";
import {ProyectoService} from "../../services/proyecto.service";
import {Navigation} from "../../services/navigation.service";
import {ZonaService} from "../../services/zona.service";
import {PlanoService} from "../../services/plano.service";
import {plano} from "../../models/plano";
import {luminaria} from "../../models/luminaria";
import {LuminariaService} from "../../services/luminaria.service";
import {MatDialog} from "@angular/material/dialog";
import {NewZoneComponent} from "./new-zone/new-zone.component";
import {DeleteZoneComponent} from "./delete-zone/delete-zone.component";
import {InfoZoneComponent} from "./info-zone/info-zone.component";
import {sensor} from "../../models/sensor";
import {SensorService} from "../../services/sensor.service";
import {UserService} from '../../services/user.service';
import {Roles} from '../../commons/util';

@Component({
  selector: 'app-zones',
  templateUrl: './zones.component.html',
  styleUrls: ['./zones.component.css']
})
export class ZonesComponent implements OnInit {

  zonasReal: Array<any> = [];
  zonas: Array<any> = undefined;
  zonasNumber: number = undefined;
  loadingZonas: boolean = true;
  actualPage: number = 1;
  planos: Array<plano> = [];
  luminarias: Array<luminaria> = undefined;
  luminariasAdded: boolean = false;
  sensores: Array<sensor> = undefined;
  sensoresAdded: boolean = false;

  constructor(public localiser: Localiser, private proyectoService: ProyectoService, private navigation: Navigation,
              private zonaService: ZonaService, private planoService: PlanoService, private luminariaService: LuminariaService,
              private sensorService: SensorService, public matDialog: MatDialog, private changeDetectorRef: ChangeDetectorRef,
              public user: UserService) {
    if (!this.proyectoService.proyectoActualCookie()) {
      proyectoService.setTrueSelectALocation("zones");
      this.toLocations();
    } else {
      proyectoService.setLastPage("zones")
    }
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    this.getZones();
    this.getPlanos();
    this.getLuminarias();
    this.getSensores();
  }

  getZones() {
    this.zonasReal = [];
    this.sensoresAdded = false;
    this.luminariasAdded = false;
    this.zonaService.getCountByIDProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe((result: number) => {
      this.zonasNumber = result;
      if (this.zonasNumber > 8) {
        this.getZonasPaginatedRecursive(1);
      } else {
        this.loadingZonas = false;
      }
    });
    this.getZonasPaginated(0);
  }

  getZonasPaginatedRecursive(page) {
    if (page < Math.ceil(this.zonasNumber / 8)) {
      this.getZonasPaginated(page);
      this.getZonasPaginatedRecursive(page + 1);
    }
  }

  getZonasPaginated(page) {
    this.zonaService.getByIDProyectoPaginated(this.proyectoService.getProyectoActual().idProyecto, page).subscribe((result: Array<zona>) => {
      this.zonasReal = this.zonasReal.concat(result);
      if (this.zonasNumber == this.zonasReal.length) {
        this.loadingZonas = false;
      }
      this.paginateZonas(1, 8);
    })
  }

  /*
    Show only 7 floorplans in the list
   */
  paginateZonas(page, n) {
    if (page > Math.ceil(this.zonasReal.length / n)) {
      page = Math.ceil(this.zonasReal.length / n);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualPage = page;
    this.zonas = this.zonasReal.slice(n * (page - 1), n * page);
    this.addDevices();
  }

  changePageByNumber(page) {
    if (page != undefined) {
      this.actualPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.paginateZonas(page, 8);
    }
  }

  outInputChangePageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.paginateZonas(1, 8);
    }
  }

  changePageByArrow(nextPage: number) {
    this.paginateZonas(this.actualPage + nextPage, 8);
  }

  isLastPage() {
    return Math.ceil(this.zonasReal.length / 8) == this.actualPage || Math.ceil(this.zonasReal.length / 8) <= 1;
  }


  getPlanos() {
    this.planoService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.planos = <Array<plano>> result;
    });
  }

  getLuminarias() {
    this.luminariasAdded = false;
    this.luminariaService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.luminarias = <Array<luminaria>> result;
      this.putLuminariasInZonas();
    });
  }

  getSensores() {
    this.sensoresAdded = false;
    this.sensorService.getByIdProyecto(this.proyectoService.getProyectoActual().idProyecto).subscribe(result => {
      this.sensores = <Array<sensor>> result;
      this.putSensoresInZonas();
    });
  }

  newZone() {
    let dialog = this.matDialog.open(NewZoneComponent, {
      width: '70%',
      height: '90%',
      data: {planos: this.planos, zona: undefined, luminarias: this.luminarias}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init()
      }
    });
  }

  editZone(zonaEdit) {
    let dialog = this.matDialog.open(NewZoneComponent, {
      width: '70%',
      height: '90%',
      data: {planos: this.planos, zona: zonaEdit, luminarias: this.luminarias}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init()
      }
    });
  }

  infoZone(zona) {
    let dialog = this.matDialog.open(InfoZoneComponent, {
      width: '70%',
      height: '75%',
      data: {planos: this.planos, zona: zona}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init()
      }
    });
  }

  deleteZone(zona) {
    let dialog = this.matDialog.open(DeleteZoneComponent, {
      width: '70%',
      height: '75%',
      data: {planos: this.planos, zona: zona}
    });

    dialog.afterClosed().subscribe((action: boolean) => {
      if (action) {
        this.init()
      }
    });
  }

  addDevices() {
    this.putLuminariasInZonas();
    this.putSensoresInZonas();
  }

  putLuminariasInZonas() {
    if (this.luminarias != undefined && this.zonas != undefined && this.zonasReal.length == this.zonasNumber) {
      for (let zona of this.zonasReal) {
        zona.luminarias = this.luminarias.filter(luminaria => luminaria.idZona == zona.id);
        if (this.luminarias.filter(luminaria => luminaria.idZona == zona.id) == undefined) {
          zona.luminarias = [];
        }
      }
      this.luminariasAdded = true;
    }
  }

  putSensoresInZonas() {
    if (this.sensores != undefined && this.zonas != undefined && this.zonasReal.length == this.zonasNumber) {
      for (let zona of this.zonasReal) {
        zona.sensores = this.sensores.filter(sensor => sensor.idZona == zona.id);
        if (this.sensores.filter(sensor => sensor.idZona == zona.id) == undefined) {
          zona.sensores = [];
        }
      }
      this.sensoresAdded = true;
    }
  }

  getPlanoNameByID(idPlano: string) {
    if (this.planos.find(plano => plano.idPlano == idPlano) != undefined) {
      return this.planos.find(plano => plano.idPlano == idPlano).nombre;
    }
  }

  toLocations() {
    this.navigation.toLocations();
  }

  public readonly Roles = Roles;
}
